export default __webpack_public_path__ + "static/media/payments.4aef4e04.PNG";